// extracted by mini-css-extract-plugin
export default {"successLog":"Outros_successLog__BzrX2","errorLog":"Outros_errorLog__Gu+DW"};